export const RightClick = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="12"
            viewBox="0 0 16 16"
            fill="none">
            <path
                d="M16.6663 5L7.49967 14.1667L3.33301 10"
                stroke="#054757"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}